import fetcher, { BASE_URL } from '../../services/fetch';
export const services = {
  get995Price: () => {
    return fetcher.get(BASE_URL + 'api/prices').then(response =>
      Object.entries(response.data)
        .map(([k, v]) => ({
          [k]: {
            BUY: v.BUY.value,
            BOARD: v.BOARD.value,
            BUYBACK: v.BUYBACK.value,
          },
        }))
        .reduce((p, c) => ({ ...p, ...c }))
    );
  },

  getInvoiceList: (params = {}) => {
    const mergedParams = { ...params };

    const queryString = new URLSearchParams(mergedParams).toString();
    const url =
      BASE_URL + 'api/transactions' + (queryString ? `?${queryString}` : '');
    return fetcher.get(url).then(response => response.data);
  },

  getInvoicePdf: async (params = {}) => {
    const mergedParams = { ...params };
    let idList = [];

    if (mergedParams.ids && Array.isArray(mergedParams.ids)) {
      idList = [...mergedParams.ids];
      mergedParams.ids = mergedParams.ids.join(',');
    }

    const queryString = new URLSearchParams(mergedParams).toString();
    const url =
      BASE_URL +
      'api/transactions/invoice' +
      (queryString ? `?${queryString}` : '');

    return fetcher
      .get(url, {
        responseType: 'blob',
      })
      .then(response => {
        const getHeader = key =>
          response.headers?.[key] || response.headers?.get?.(key);

        const contentType = getHeader('content-type') || 'application/pdf';

        // 2. Create a Blob using the dynamic type (pdf OR gzip)
        const blob = new Blob([response.data], { type: contentType });

        // 3. Determine the correct filename
        let filename = `invoices-${idList[0]}.pdf`; // Default to pdf

        const disposition = getHeader('content-disposition');
        if (disposition && disposition.includes('filename=')) {
          // Extract the filename your backend set (e.g. "invoices.tar.gz")
          const filenameMatch = disposition.match(/filename="?([^"]+)"?/);
          if (filenameMatch && filenameMatch[1]) {
            filename = filenameMatch[1];
          }
        } else if (
          contentType === 'application/gzip' ||
          contentType === 'application/x-gzip'
        ) {
          filename = `invoices-${new Date().toLocaleDateString('fa-IR')}.tar.gz`;
        }

        // 4. Trigger download
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.setAttribute('download', filename);

        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(downloadUrl);

        return true;
      });
  },

  set995Price: async price => {
    return fetcher.post(BASE_URL + 'api/prices', { value: price });
  },
  setUploadData: data => {
    return fetcher.post(BASE_URL + 'api/assets/delivery/', { bullions: data });
  },
  getInventoryStatus: params => {
    // Build query string from mergedParams
    const queryString = new URLSearchParams(params).toString();
    const url =
      BASE_URL + 'api/assets' + (queryString ? `?${queryString}` : '');
    return fetcher.get(url).then(response => response.data);
  },
  getTreasuryChargeStatus: params => {
    // Build query string from mergedParams
    const queryString = new URLSearchParams(params).toString();
    const url =
      BASE_URL + 'api/assets/charge' + (queryString ? `?${queryString}` : '');
    return fetcher.get(url).then(response => response.data);
  },
  getRates: () => {
    return fetcher
      .get(BASE_URL + 'api/prices/rates')
      .then(response => response.data);
  },
  getEstjPrices: async () => {
    try {
      // ۱. دریافت سورس فعال و آدرس مربوط به آن از دیتابیس
      const sourceRes = await fetcher
        .get(BASE_URL + 'api/prices/get-price-source')
        .then(res => res.data)
        .catch(() => ({
          source: 'ESTJT',
          endpoint: 'https://monitor.narintejarat.ir/api/prices/estj', // فال‌بک در صورت قطعی
        }));

      const endpoint =
        sourceRes?.endpoint ||
        'https://monitor.narintejarat.ir/api/prices/estj';

      // ۲. دریافت قیمت مستقیماً از آدرس همان سورس
      const response = await fetcher.get(endpoint);
      const priceData = response.data;

      return {
        gold24k: priceData.gold24k ?? priceData.faraz24k ?? 0,
        methghal: priceData.methghal ?? priceData.farazMethghal ?? 0,
        gold18k: priceData.gold18k ?? 0,
        timestamp:
          priceData.timestamp ?? priceData.farazTimestamp ?? Date.now(),
        source: sourceRes.source,
      };
    } catch (error) {
      console.error('[getEstjPrices] Error fetching price:', error);
      return {
        gold24k: 0,
        methghal: 0,
        gold18k: 0,
        timestamp: Date.now(),
      };
    }
  },

  getAvailablePriceSources: () => {
    return fetcher
      .get(BASE_URL + 'api/prices/get-available-price-sources')
      .then(response => response.data);
  },

  getTodayBuyback: () => {
    return fetcher
      .get('https://customer.in.eqlimashemsh.ir/api/buyback/today', {
        headers: {
          token:
            'BDJyqzWR2GIYgMlEYCLvTMfbcqQtWqHwEt7Duk8V4PRXAAOFsfxVX44eAfrSxipp',
        },
      })
      .then(response => response.data);
  },

  getBuybackHistory: () => {
    return fetcher
      .get('https://customer.in.eqlimashemsh.ir/api/buyback', {
        headers: {
          token:
            'BDJyqzWR2GIYgMlEYCLvTMfbcqQtWqHwEt7Duk8V4PRXAAOFsfxVX44eAfrSxipp',
        },
      })
      .then(response => response.data);
  },

  getGramPrice: () => {
    return fetcher
      .get('https://api.narintejarat.ir/api/sales/prices')
      .then(response => response.data);
  },
  setBuyBackPrice: ({ buybackPrice }) => {
    return fetcher
      .post(
        BASE_URL + 'api/prices/set-config',
        {
          buybackPrice,
        }
        // {
        //   headers: {
        //     token: 'grs5t/1xzcwtlz7r6TPEq85Nz9g0SfF6B1KKDf0pxvI=',
        //   },
        // }
      )
      .then(response => response.data);
  },
  setRates: (type, newRate) => {
    return fetcher
      .post(BASE_URL + 'api/prices/rates', { type, newRate })
      .then(response => response.data);
  },
  setProductConfig: data => {
    return fetcher
      .post(BASE_URL + 'api/prices/set-product-config', {
        ...data,
      })
      .then(response => response.data);
  },
  getProductsConfig: ({ strategy, buybackStrategy }) => {
    return fetcher
      .get(BASE_URL + 'api/prices/get-products-config', {
        params: { strategy, buybackStrategy },
      })
      .then(response => response.data);
  },
  getPriceSource: () => {
    return fetcher
      .get(BASE_URL + 'api/prices/get-price-source')
      .then(response => response.data);
  },

  setPriceSource: ({ source }) => {
    return fetcher
      .post(BASE_URL + 'api/prices/set-price-source', {
        source,
      })
      .then(response => response.data);
  },

  getSellVolumeStats: () => {
    return fetcher
      .get(BASE_URL + 'api/transactions/get-sell-volume-stat')
      .then(response => response.data);
  },

  getTransactionsByDate: async params => {
    const response = await fetcher
      .get(BASE_URL + 'api/transactions/by-date', {
        params,
      })
      .then(response => response.data);

    return response;
  },

  renewInvoice: id => {
    const url = BASE_URL + 'api/transactions/renew' + (id ? `/${id}` : '');
    return fetcher.get(url).then(response => response);
  },
  setConfig: ({ manualBasePrice, costPercentage, strategy }) => {
    return fetcher
      .post(BASE_URL + 'api/prices/set-config', {
        manualBasePrice,
        costPercentage,
        strategy,
      })
      .then(response => response.data);
  },
  getCompetitorPrices: () => {
    return fetcher
      .get('https://monitor.narintejarat.ir/api/prices/servat')
      .then(res => res.data);
  },
  getChartData: (bullion, sources, timeframe) => {
    const string = JSON.stringify(sources);
    return fetcher
      .get(
        `https://market-chart.narintejarat.ir/api/report/threads/price/multi-history?bullionType=${bullion}&sources=${string}&timeframe=${timeframe}`
      )
      .then(res => res.data);
  },
};
